import Vue from 'vue'
import VueRouter from 'vue-router'
import Setting from '../views/setting.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'setting',
    component: Setting
  },
  {
    path: '/logs',
    name: 'logs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/logs.vue')
  },
  {
    path: '/result',
    name: 'result',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/result.vue')
  }
];

const router = new VueRouter({
  routes
});

export default router
